/**
 * Copyright © 2026 Adnuntius AS.
 */
import _ from 'lodash';

export const creativeSetListCommons = function(ctrl, afterFill, LocalNetworkProfile, adnTimeShifter) {
  void adnTimeShifter;
  _.forEach(ctrl.items, function(li) {
    if (li.startDate) {
      li.modStartDate = li.startDate;
    }
    if (li.endDate) {
      li.modEndDate = li.endDate;
    }
  });

  if (afterFill) {
    return;
  }

  ctrl.allFields = ['name', 'userState', {label: 'folio', param: 'Folio'}, 'startDate', 'endDate', 'createUser', 'updateTime', 'recentlyRequested'];

  const skipForDefaults = ['createUser', 'updateTime'];
  ctrl.defaultFields = _.filter(ctrl.allFields, function(f) {
    return skipForDefaults.indexOf(f.label || f.param || f) < 0;
  });
  ctrl.sel = {};
};
